import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "title-big t-blue uppercase text-center mr-5 mb-2 ml-2" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "mr-2 input-slim first-name" }
const _hoisted_5 = { class: "account-select-double mr-2 title-data mb-2" }
const _hoisted_6 = { class: "uppercase text-raleway-13" }
const _hoisted_7 = { class: "double-select" }
const _hoisted_8 = { class: "uppercase text-raleway-13" }
const _hoisted_9 = { class: "uppercase text-raleway-13" }
const _hoisted_10 = { class: "uppercase text-raleway-13" }
const _hoisted_11 = { class: "uppercase text-raleway-13" }
const _hoisted_12 = { class: "text-raleway-13 pl-1" }
const _hoisted_13 = {
  class: "btn btn-default mt-2 w-100",
  type: "submit"
}
const _hoisted_14 = { class: "uppercase text-raleway-13 t-danger text-center" }

import { RegistrationDataComponentValidation } from "../../utils/validation/registration/registration";
import { RegistrationDetails } from "@/store/modules/accountDetails/type";
import SelectComponent from "@/components/select/SelectComponent.vue";
import { UserTypeOperation } from "@/store/modules/User/type";
import { IStore } from "@/store/types/StoreType";
import { Field, useForm } from "vee-validate";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

import PhoneComponent from "@/components/phone/phoneComponent.vue";
import PasswordComponent from "../password/passwordComponent.vue";
import { useFetch } from "@/hook/fetch/fetch";
import { RegistrationType } from "./type";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationComponents',
  setup(__props) {

const title = ref(["Mr", "Mrs", "Ms"]);

const errorMessageArray = ref<string[]>([]);

const store = useStore<IStore>();
const initialValues = ref<RegistrationDetails>(
  store?.getters?.getRegistrationDataComponentValues
);

const { errors, values, validate } = useForm<RegistrationDetails>({
  initialValues: { ...initialValues.value },
  validationSchema: RegistrationDataComponentValidation,
});

const userData = ref(
  computed<UserTypeOperation>(() => store?.getters?.getSelectUser)
);
const registration = () => {
  errorMessageArray.value = [];
  validate().then(async (result) => {
    const registrationData = {
      ...values,
      phone: values.user_phone_start + values.user_phone,
      title: values.title || "1",
    };
    if (!result.valid) return;
    const { isError, errorMessage } = await useFetch<RegistrationType, any>(
      process.env.VUE_APP_SERVER + "api/users/",
      "POST",
      false,
      {
        ...registrationData,
        ui_language: store.getters.getUserUiLang.toUpperCase(),
      }
    );
    if (isError.value && errorMessage?.value) {
      errorMessageArray.value = errorMessage?.value;
      return;
    }
    store.dispatch("userLogin", {
      ...values,
      replace: "account",
    });
    store.commit("updateAccountDetailsUserCustomer", {
      firm_name: values.first_name + ' ' + values.last_name,
      firm_name2: values.last_name,
      title: registrationData.title,
      buyer_phone: values.user_phone_start + values.user_phone,
      buyer_vat: "",
      fax: "",
      email: values.email,
      buyer_name: values.last_name,
      buyer_address: "",
      location: null,
      manager: null,
      phone: values.user_phone_start + values.user_phone,
      creation_time: new Date(),
    });
  });
};

const titleValue = ref(userData.value?.title ? title.value[+userData.value?.title - 1] : 'Mr')

watch(values, () => {
  store.commit("updateRegistrationValues", values);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _withModifiers(registration, ["prevent"])
  }, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$tc("Register")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$tc("Title")), 1),
          _createVNode(SelectComponent, {
            options: title.value,
            default: titleValue.value,
            class: "select",
            name: 'title',
            "key-or-value": true,
            disabled: true
          }, null, 8, ["options", "default"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["input-slim", { 'error-input mini': !!_unref(errors)?.first_name }])
      }, [
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$tc("first name")), 1),
        _createVNode(_unref(Field), {
          tabindex: 2,
          maxlength: "30",
          type: "text",
          name: "first_name",
          class: "input input-mini",
          value: _unref(values)?.first_name || '',
          placeholder: _ctx.$tc('first name')
        }, null, 8, ["value", "placeholder"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["input-slim", { 'error-input mini': !!_unref(errors)?.last_name }])
      }, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$tc("last name")), 1),
        _createVNode(_unref(Field), {
          tabindex: 3,
          maxlength: "30",
          type: "text",
          name: "last_name",
          class: "input input-mini",
          value: _unref(values)?.last_name || '',
          placeholder: _ctx.$tc('last name')
        }, null, 8, ["value", "placeholder"])
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["mb-1 w-100", { 'error-input mini': !!_unref(errors)?.user_phone }])
    }, [
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$tc("phone number")), 1),
      _createVNode(PhoneComponent, {
        tabindex: 4,
        class: _normalizeClass({ 'error-input_phone': !!_unref(errors)?.user_phone, 'w-100': true }),
        value: _unref(values)?.user_phone || '',
        name: 'user_phone',
        start: _unref(values).user_phone_start || '',
        change: 'changeStartValue_user_phone_start_registration'
      }, null, 8, ["class", "value", "start"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mr-2 w-100", { 'error-input mini': !!_unref(errors)?.email }])
    }, [
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$tc("Email address")), 1),
      _createVNode(_unref(Field), {
        tabindex: 5,
        maxlength: "55",
        type: "text",
        name: "email",
        class: "input input-mini",
        placeholder: _ctx.$tc('Email address')
      }, null, 8, ["placeholder"])
    ], 2),
    _createVNode(PasswordComponent, {
      "tab-index": 6,
      error: !!_unref(errors).password,
      change: () => {},
      name: 'password',
      value: _unref(values).password,
      mini: true
    }, null, 8, ["error", "value"]),
    _createVNode(PasswordComponent, {
      "tab-index": 7,
      error: !!_unref(errors).password_confirm,
      change: () => {},
      name: 'password_confirm',
      text: 'confirm password',
      value: _unref(values).password_confirm,
      mini: true
    }, null, 8, ["error", "value"]),
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex a-i-start mt-2", { 'error-input mini private': !!_unref(errors)?.private }])
    }, [
      _createVNode(_unref(Field), {
        maxlength: "55",
        class: "checkbox mt-1",
        type: "checkbox",
        name: "private",
        tabindex: "8",
        modelValue: initialValues.value.private,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((initialValues.value.private) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("p", _hoisted_12, [
        _createTextVNode(_toDisplayString(_ctx.$t("personal_data")) + " ", 1),
        _createVNode(_component_router_link, {
          class: "text text-raleway-13 error pointer t-danger",
          to: { name: 'private_policy' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tc("privacy_policy")) + " .", 1)
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$tc("Register")), 1),
    _withDirectives(_createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(errorMessageArray.value), (error, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "mb-2"
        }, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(error[0] + " : " + error[1]), 1)
        ]))
      }), 128))
    ], 512), [
      [_vShow, Array(errorMessageArray.value)?.length > 0]
    ])
  ], 40, _hoisted_1))
}
}

})